import React from "react";

export const UiGrayBox = (props) => {
    return (
        <>
            <div className="sb-gray-box">
                {props.children}
            </div>
        </>
    )
}